import React, { useEffect } from 'react';
import DailyCheckinConfetti from './DailyCheckinConfetti';
import './DailyCheckinRewardModal.css';

const toNonNegativeInt = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.round(parsed));
};

const DailyCheckinRewardModal = ({ reward = null, onClose }) => {
  const pointsAwarded = toNonNegativeInt(reward?.pointsAwarded);
  const checkinStreak = toNonNegativeInt(reward?.checkinStreak);
  const streakMilestone = toNonNegativeInt(reward?.streakMilestone);

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  useEffect(() => {
    if (!reward) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && typeof onClose === 'function') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, reward]);

  if (!reward || pointsAwarded <= 0) return null;

  const milestoneMessage =
    streakMilestone > 0 ? `${streakMilestone}-day streak bonus included.` : null;

  return (
    <div className="daily-checkin-reward-overlay" onClick={handleClose}>
      <DailyCheckinConfetti active={Boolean(reward)} />
      <div
        className="daily-checkin-reward-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="daily-checkin-reward-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="daily-checkin-reward-close"
          onClick={handleClose}
          aria-label="Close check-in reward dialog"
        >
          &times;
        </button>

        <h2 id="daily-checkin-reward-title">Daily check-in reward</h2>
        <p className="daily-checkin-reward-copy">You earned points for checking in today.</p>

        <div className="daily-checkin-reward-points">+{pointsAwarded} pts</div>

        <p className="daily-checkin-reward-streak">
          Current check-in streak: <strong>{checkinStreak}</strong> day{checkinStreak === 1 ? '' : 's'}
        </p>

        {milestoneMessage && (
          <p className="daily-checkin-reward-milestone">{milestoneMessage}</p>
        )}

        <button type="button" className="daily-checkin-reward-button" onClick={handleClose}>
          Keep it going
        </button>
      </div>
    </div>
  );
};

export default DailyCheckinRewardModal;
